import { createPageEntryPoint } from '@atlassian/jira-create-route-entry-point/src/index.tsx';
import { deploymentFrequencyReportEntrypoint } from '@atlassian/jira-spa-apps-software-reports-deployment-frequency-report/entrypoint.tsx';
import { MENU_ID } from '@atlassian/jira-navigation-apps-common/src/constants.tsx';

export const DeploymentFrequencyPageEntrypoint = createPageEntryPoint({
	main: deploymentFrequencyReportEntrypoint,
	topNavigationMenuId: MENU_ID.PROJECTS,
});
